import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getMonthYear } from '../../../../../utils';
import { dateFormatter } from '../../../../../utils';
import { request } from '../../../../../utils';
import { toast } from '../../../../../utils';
import axios from 'axios';

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.main?.name
  }
];

const STOCK_STATUS_HEADER = [
  {
    header: 'CNT/GRN',
    accessor: (row) => row?.productDetails?.cnt
  },
  {
    header: 'Location',
    accessor: (row) => row?.location?.location
  },
  {
    header: 'Batch No.',
    accessor: 'batch_no'
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row?.productDetails?.exp_date)
  },
  {
    header: 'Stock',
    accessor: 'totalQuantity'
  }
];

const PURCHASE_HISTORY_HEADER = [
  {
    header: 'Type',
    accessor: (row) => {
      if (row?.cnt.startsWith('CNT-')) {
        return 'CNT';
      } else if (row?.cnt.startsWith('GRN-')) {
        return 'GRN';
      }
      return row?.cnt;
    }
  },
  {
    header: 'Dated',
    accessor: (row) => dateFormatter(row?.invoice_date)
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Qty',
    accessor: (row) => row?.add_details[0]?.rec_qty
  },
  {
    header: 'Rate',
    accessor: (row) => row?.add_details[0]?.rate
  },
  {
    header: 'MRP',
    accessor: (row) => row?.add_details[0]?.mrp
  }
];

export const PurchaseOrderAddDetails = ({
  onClose,
  chargeType = 'opd_charges',
  doctorID,
  onAdd,
  productDropdown,
  setFilteredServiceList,
  filteredServiceList,
  setProductDropdown
}) => {
  const [input, setInput] = useState('');
  const [activeTab, setActiveTab] = useState(1);
  const [consignment, setConsignment] = useState([]);
  const [grnDetails, setGrnDetails] = useState([]);
  const [totalStock, setTotalStock] = useState(0);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        product: Yup.string().required('Please Enter Product')
        // bill_qty: Yup.string().required('Please Enter Product'),
        // rate: Yup.string().required('Please Enter Product'),
        // batch_no: Yup.string().required('Please Enter Batch No'),
        // exp_date: Yup.string().required('Please Enter Exp Date'),
        // mrp: Yup.string().required('Please Enter Product'),
        // sal_rate: Yup.string().required('Please Enter Sale Date')
      })
    ),
    defaultValues: {
      po_qty: 0,
      del_date: new Date().toISOString().split('T')[0],
      free_qty: 0,
      loose_qty: 0,
      rec_qty: 0,
      quantity: 1,
      amount: 0,
      net_amt: 0,
      gst_amt: 0,
      disc_amt: 0,
      disc_per: 0,
      gst_per: 0,
      sgst: 0,
      cgst: 0
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
    const productId = productDropdown.find(({ main }) => main?.name === formValues.product)?._id || '';
    const transformedValues = {
      ...formValues,
      product: productId
    };
    onAdd(transformedValues);
    reset();
  };

  const handleServiceSelection = (row) => {
    setGrnDetails([]);
    setTotalStock([]);
    const isProduct = productDropdown.some((product) => product._id === row._id);
    if (isProduct) {
      setValue('rate', row[chargeType] || 0);
    }
    methods.resetField('product');
    setValue('product', row?.main?.name);
    setValue('unit', row?.main?.purchasing_unit?.unit_name);
    setValue('hsn_code', row?.main?.hsn_code);
    setValue('gst', row?.main?.tax_percentage);
    setValue('packing', row?.main?.packing);
    setValue('conversion', row?.main?.conversion);
    handleProductSearchGrn(row?._id);
    handleTotalStock(row?._id);
  };

  const billQty = watch('order_qty');
  const rate = watch('rate');
  const freeQty = watch('free_qty');
  const discPerWatch = watch('disc_percent');
  const discAmtWatch = watch('dis_amt');
  const gstPerWatch = watch('gst');
  const mrp = watch('mrp');

  useEffect(() => {
    const amount = billQty * rate || 0;
    const RecQty = Number(freeQty) + Number(billQty);
    const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
    const taxable = parseFloat((amount - discAmt).toFixed(2));
    const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
    const netAmt = parseFloat((Number(taxable) + Number(gstAmt)).toFixed(2));
    const sgst = gstAmt / 2;
    setValue('amount', parseFloat(amount.toFixed(2)));
    setValue('dis_amt', discAmt || 0);
    setValue('gst_amt', gstAmt || 0);
    setValue('taxable', taxable || 0);
    setValue('rec_qty', RecQty || 0);
    setValue('sal_rate', mrp || 0);
    setValue('net_amt', netAmt || 0);
    setValue('sgst', sgst || 0);
    setValue('cgst', sgst || 0);
  }, [billQty, rate, discPerWatch, gstPerWatch, freeQty, setValue]);

  useEffect(() => {
    if (billQty && rate && discAmtWatch !== undefined) {
      const amount = billQty * rate;
      const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(2));
      setValue('disc_percent', newDiscPer);
    }
  }, [billQty, rate, discAmtWatch, setValue]);

  useEffect(() => {
    if (mrp !== undefined) {
      setValue('sal_rate', mrp);
    }
  }, [mrp, setValue]);

  useEffect(() => {
    handleProductSearch(input);
  }, [input]);

  const handleProductSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
   
      try {
        const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${50}&name=${lowercasedInput}`);
        if (response.data.success) {
          setProductDropdown(response.data.data);
          setFilteredServiceList(response.data.data);
        } else {
          toast('Error in fetching data', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
      }
 
  };

  const handleInputChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };
  const product = watch('product');

  const getConsignmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('consignment-receipt-add-details');
    setConsignment(data);
  }, []);

  useEffect(() => {
    getConsignmentDropdown();
  }, [getConsignmentDropdown]);

  const handleProductSearchGrn = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/cnt-grn-details/list?name=${rowId}`);
      if (response.data.success) {
        setGrnDetails(response.data.data);
      }
    } catch (error) {
      console.error('Error during search:', error);
    }
  };

  const handleTotalStock = async (rowId) => {
    try {
      const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
      if (response.data.success && response.data.data.length > 0) {
        const totalQuantity = response.data.data;
        setTotalStock(totalQuantity);
      }
    } catch (error) {
      console.error('Error during search:', error);
    }
  };

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="0px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={4}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Typography variant="h6">No. Of Product :- {productDropdown.length}</Typography>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
              <MuiTextField
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    padding: '0'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px'
                  }
                }}
                label="Search Product"
                variant="outlined"
                value={input}
                onChange={handleInputChange}
                InputProps={{
                  style: {
                    fontSize: '12px',
                    fontWeight: 600
                  }
                }}
              />
            </Stack>
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              sx={{ fontSize: '32px' }}
              data={filteredServiceList || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={8}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product</Typography>
                <TextField sx={{ flex: 1 }} name="product" placeholder="Select Product" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Del. Date</Typography>
                <TextField type="date" sx={{ flex: 0.4 }} name="del_date" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                <TextField sx={{ flex: 0.38 }} disabled name="unit" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Packing</Typography>
                <TextField sx={{ flex: 0.4 }} name="packing" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.39, fontWeight: 700, fontSize: '1.4rem' }}>Order Qty</Typography>
                <TextField sx={{ flex: 0.38 }} name="order_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Free Qty</Typography>
                <TextField sx={{ flex: 0.38 }} name="free_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="total_qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.4 }} name="rate" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                <TextField sx={{ flex: 0.4 }} name="amount" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Dis%</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="disc_percent" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Dis Amt.</Typography>
                <TextField sx={{ flex: 0.4 }} name="dis_amt" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Taxable</Typography>
                <TextField sx={{ flex: 0.4 }} name="taxable" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>HSN Code</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="hsn_code" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
                <TextField sx={{ flex: 0.4 }} name="mrp" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="gst" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>SGST</Typography>
                <TextField sx={{ flex: 0.4 }} name="sgst" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>CGST</Typography>
                <TextField sx={{ flex: 0.4 }} name="cgst" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>IGST</Typography>
                <TextField sx={{ flex: 0.4 }} name="igst" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                <TextField sx={{ flex: 0.4 }} name="net_amt" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
              <Button
                variant="contained"
                onClick={() => handleActiveTab(1)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  backgroundColor: activeTab === 1 ? 'primary.main' : 'default',
                  color: activeTab === 1 ? 'white' : 'text.primary'
                }}
              >
                Stock Status
              </Button>
              <Button
                variant="contained"
                onClick={() => handleActiveTab(2)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  backgroundColor: activeTab === 2 ? 'primary.main' : 'default',
                  color: activeTab === 2 ? 'white' : 'text.primary'
                }}
              >
                Purchase History
              </Button>
            </Box>
            {activeTab === 1 && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={totalStock || []}
                  columns={STOCK_STATUS_HEADER}
                  size="small"
                />
              </Stack>
            )}
            {activeTab === 2 && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={grnDetails || []}
                  columns={PURCHASE_HISTORY_HEADER}
                  size="small"
                />
              </Stack>
            )}
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
